import React from 'react';
import styled, { keyframes } from 'styled-components';
import { useRealTimeUpdates } from '../../utils/realTimeUpdates';
import { useLanguage } from '../../i18n/LanguageContext';

const pulse = keyframes`
  0% { transform: scale(1); box-shadow: 0 0 0 0 rgba(0, 71, 68, 0.6); }
  70% { transform: scale(1.02); box-shadow: 0 0 0 12px rgba(0, 71, 68, 0); }
  100% { transform: scale(1); box-shadow: 0 0 0 0 rgba(0, 71, 68, 0); }
`;

const Container = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  margin: 12px 0 0 0;
  z-index: 2;
`;

const Badge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  background: rgba(0, 71, 68, 0.15);
  border: 1px solid rgba(0, 71, 68, 0.5);
  color: #004744;
  padding: 10px 16px;
  border-radius: 999px;
  font-weight: 700;
  letter-spacing: 0.3px;
  backdrop-filter: blur(6px);
  animation: ${pulse} 2.5s ease-in-out infinite;
`;

const Dot = styled.span`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #004744;
  box-shadow: 0 0 0 4px rgba(0, 71, 68, 0.25);
`;

const Number = styled.span`
  font-size: 1.05rem;
`;

const Label = styled.span`
  font-size: 0.95rem;
  color: #004744;
`;

const LiveVisitorCounter: React.FC = () => {
  const { data, connectionStatus } = useRealTimeUpdates();
  const { language } = useLanguage();

  const label = language === 'it' ? 'Visitatori online' : 'Visitors online';
  const value = Math.max(typeof data?.onlineUsers === 'number' ? data.onlineUsers : 0, 1);

  return (
    <Container aria-live="polite" aria-atomic="true">
      <Badge title={connectionStatus === 'connected' ? label : `${label} (simulazione)`}>
        <Dot aria-hidden="true" />
        <Label>{label}:</Label>
        <Number>{value}</Number>
      </Badge>
    </Container>
  );
};

export default LiveVisitorCounter;
